import '/components/text-with-image/text-with-image.scss';
